<template>

    <div id="project-list">

        <div v-if="show_menu" class="row project-list-header">
            <div class="col-xs-6" style="line-height: 34px;">
                총 <span class="text-primary">{{ total }}</span>건
            </div>
            <div class="col-xs-6 text-right">
                <div class="btn-group" role="group">
                    <button @click="show_filter = ! show_filter" class="btn btn-default" title="검색창 토글"><i class="fas fa-search-plus"></i></button>
                    <!--<button @click="show_pagination = ! show_pagination" class="btn btn-default" title="페이지 토글"><i class="fas fa-map-signs"></i></button>-->
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="보기 모드" style="width: 40px;">
                        <span v-show="list_view_mode == 'list'"><i class="fas fa-list-ul"></i></span>
                        <span v-show="list_view_mode == 'card'"><i class="fas fa-th-large"></i></span>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a href="#" @click="setListViewMode('list')">목록형</a></li>
                        <li><a href="#" @click="setListViewMode('card')">카드형</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="show_filter" class="panel panel-default">
            <div class="panel-body">

                <div class="input-group mb-4 pb-4 border-b" style="display: none;">
                    <input type="text" class="form-control" placeholder="검색어를 입력 후 엔터!!"
                           v-model.trim.lazy="filter.wr_subject">
                    <span class="input-group-btn">
                        <button @click="onClickedResetFilter" class="btn btn-default" type="button">초기화</button>
                        <button @click="onClickedFilterSubmit" class="btn btn-default" type="button">검색</button>
                    </span>
                </div>

                <div class="form-inline">
                    <!--<div class="input-group">-->
                        <!--<span class="input-group-addon">카테고리</span>-->
                        <!--<select class="form-control" v-model="filter.ca_name">-->
                            <!--<option value="">전체</option>-->
                            <!--<option value="SW">SW</option>-->
                            <!--<option value="APP">APP</option>-->
                            <!--<option value="WEB">WEB</option>-->
                            <!--<option value="IoT">IoT</option>-->
                            <!--<option value="기타">기타</option>-->
                        <!--</select>-->
                    <!--</div>-->
                    <!--<div class="input-group">-->
                        <!--<span class="input-group-addon">지원결과</span>-->
                        <!--<select class="form-control" v-model="filter.application_status">-->
                            <!--<option value="">전체</option>-->
                            <!--<option value="pending">심사중</option>-->
                            <!--<option value="pass">합격</option>-->
                            <!--<option value="fail">탈락</option>-->
                            <!--<option value="cancel">취소</option>-->
                        <!--</select>-->
                    <!--</div>-->
                    <div class="input-group">
                        <span class="input-group-addon">프로젝트 진행상태</span>
                        <select v-if="is_admin != 'true'" class="form-control" v-model="filter.project_step">
                            <option value="">전체</option>
                            <option value="request">대기중</option>
                            <option value="recruiting">테스터 모집중</option>
                            <option value="testing">진행중</option>
                            <option value="done">완료</option>
                        </select>
                        <select v-if="is_admin == 'true'" class="form-control" v-model="filter.project_status">
                            <option value="">전체</option>
                            <option value="request">프로젝트 신청</option>
                            <option value="request_fail">프로젝트 신청 거부</option>
                            <option value="request_pass">프로젝트 신청 승인</option>
                            <option value="recruiting">테스터 모집 중</option>
                            <option value="recruiting_done">테스터 모집 완료</option>
                            <option value="testing">테스터 진행</option>
                            <option value="testing_done">테스트 완료</option>
                            <option value="appraisal">평가 중</option>
                            <option value="done">완료</option>
                        </select>
                    </div>
                </div>

            </div>
        </div>

        <hr v-if="show_filter">

        <table v-if="list_view_mode == 'list'" class="table table-bordered table-hover" style="table-layout: fixed;">
            <thead>
            <tr>
                <th style="width: 50px;">순번</th>
                <th>제목</th>
                <th style="width: 80px;">상태</th>
                <th style="width: 120px;">생성일</th>
                <th v-if="related_with === 'tester'">지원결과</th>
                <!--<th v-if="is_admin">개설기업</th>-->
                <th style="width: 80px;">관리</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(project, index) in projects"
                @click="onClickedProject($event, project)" :class="{ active: selected_project == project.id }" style="cursor:pointer;">
                <td v-text="index + 1"></td>
                <td style="-ms-word-wrap: break-word;word-wrap: break-word;">{{ project.title }}</td>
                <td>{{ statusToKor(project.project_status) }}</td>
                <td>{{ project.created_at | moment_format_LL }}</td>
                <td v-if="related_with === 'tester'">{{ project.application_status | applicationStatusToText(project.project_status) }}</td>
                <!--<td style="-ms-word-wrap: break-word;word-wrap: break-word;" v-if="is_admin" v-text="project.mb_no"></td>-->
                <td>
                    <div class="dropdown">
                        <button class="btn btn-default btn-xs dropdown-toggle" type="button" :id="'dropdownMenu-' + index" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            관리
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" :aria-labelledby="'dropdownMenu-' + index">
                            <li><a :href="'/project/' + project.id">프로젝트 보기</a></li>
                            <li v-if="is_admin === 'true' || project.mb_no === 'user_id'"><a :href="'/project/' + project.id + '/edit'">수정하기</a></li>
                        </ul>
                    </div>
                </td>
                <!--<td v-if="project.project_status == 'recruitment'">-->
                <!--<a :href="'/user/dashboard/project_application?project_id=' + project.wr_id">선발하기</a>-->
                <!--</td>-->
                <!--<td v-else="">-->
                <!--<a :href="'/bbs/board.php?bo_table=project&wr_id=' + project.wr_id + '&sfl=project_status&stx=' + project.project_status">상세보기</a>-->
                <!--</td>-->
            </tr>
            </tbody>
        </table>

        <div v-else-if="list_view_mode == 'card'" class="row">

            <div v-for="project in projects" class="col-xs-12 col-lg-4">

                <div class="project-card rounded overflow-hidden shadow-lg">
                    <div class="project-card-header w-full h-48 bg-center bg-no-repeat bg-cover"
                         :style="{ 'background-image' : 'url(\'/application/data/attachment/' + thumbnail(project).file_name + '\')'}">

                        <div class="relative">
                            <div class="text-white opacity-75 h-8 pl-2 project-card-header__status"
                                 v-bind:class="['project-card-header__status--' + project.project_status]">{{ statusToKor(project.project_status) }}</div>
                        </div>
                    </div>
                    <div class="px-6 py-4 h-48 overflow-x-scroll pretty-scrollbar">
                        <div style="word-wrap: break-word" class="font-bold text-lg mb-2">{{ project.title }}</div>
                        <div style="word-wrap: break-word; font-size: 14px;" class="text-grey-darker" v-html="project.description.replace(/\n/g, '<br />')"></div>
                    </div>
                    <div class="px-6 py-4" style="height: 25rem;">
                        <dl class="project-card-info">
                            <dt class="text-grey-darker">모집인원</dt>
                            <dd>전문테스터 {{ project.expert_tester }}명</dd>
                            <dd>일반테스터 {{ project.normal_tester }}명</dd>
                            <dt class="text-grey-darker mt-1">모집기간</dt>
                            <dd>{{ project.application_start | moment_format_LL }} ~ {{ project.application_end | moment_format_LL }}</dd>
                            <dt class="text-grey-darker mt-1">수행기간</dt>
                            <dd>{{ project.testing_start | moment_format_LL }} ~ {{ project.testing_end | moment_format_LL }}</dd>
                            <dt class="text-grey-darker mt-1">보상</dt>
                            <dd v-html="project.reward == '' ? '보상 정보가 없습니다.' : project.reward.replace(/\n/g, '<br />')"
                                class="overflow-x-scroll pretty-scrollbar"
                                style="height: 100px; display: block; word-wrap: break-word; margin-right: -1.5rem; padding-right: 1.5rem;"></dd>
                        </dl>
                    </div>
                    <div class="px-6 py-4 border-t border-grey-light text-right">
                        <a v-if="project.project_status == 'testing'"
                           :href="'/bbs/board.php?bo_table=project_issues&project_id=' + project.id"
                           class="btn btn-default" title="프로젝트 이슈"><i class="far fa-comments"></i></a>
                        <a :href="'/project/' + project.id" class="btn btn-default" title="프로젝트 보기"><i class="far fa-file-alt"></i></a>
                    </div>
                </div>

            </div>


        </div>

        <div v-if="show_pagination" class="text-center border-t">
            <pagination :page.sync="page" :total-article="total" :base-url="base_path"></pagination>
        </div>

    </div>

</template>

<script>
    import $ from 'jquery'
    import Pagination from './Pagination'

    export default {
        name: "project-list",
        props: ['isAdmin', 'userId', 'relatedWith', 'relatedId', 'projectStatus',
            'listViewMode', 'showMenu', 'showFilter', 'showPagination', 'projectStep', 'maxCount', 'what'],
        components: {
            'pagination': Pagination
        },
        data() {
            return {
                uri: null,
                is_admin: false,
                user_id: "",
                project_status: null,
                related_with: null,
                related_id: null,
                list_view_mode: 'list',
                data: [],
                filter: {
                    application_status: '',
                    wr_subject: '',
                    mb_id: '',
                    ca_name: '',
                    project_status: '',
                    project_step: '',
                },
                page: 0,
                total: 0,
                show_menu: true,
                show_filter: true,
                show_pagination: true,
                selected_project: ""
            }
        },
        created() {

            this.is_admin   = this.isAdmin === undefined ? "" : this.isAdmin;
            this.user_id    = this.userId === undefined ? "" : this.userId;

            this.project_status = this.projectStatus === undefined ? "" : this.projectStatus;
            this.filter.project_step   = this.projectStep === undefined ? "" : this.projectStep;
            this.related_with   = this.relatedWith;
            this.related_id     = this.relatedId;

            if (this.project_status != "") this.filter.project_status = this.project_status;

            if (this.listViewMode !== undefined && this.listViewMode !== "") this.list_view_mode = this.listViewMode;

            if (this.showMenu !== undefined && this.showMenu !== "") this.show_menu = this.showMenu === "true";
            if (this.showFilter !== undefined && this.showFilter !== "") this.show_filter = this.showFilter === "true";
            if (this.showPagination !== undefined && this.showPagination !== "") this.show_pagination = this.showPagination === "true";

            let uri = "";

            if (this.what === "latest") {
                uri = "/project/latest";
            }
            else if (this.related_with === undefined || this.related_with === "") {
                uri = "/project";
            }
            else if (this.related_with === "tester") {
                uri = "/tester/" + this.related_id + "/projects";
            }
            else if (this.related_with === "company") {
                uri = "/company/" + this.related_id + "/projects";
            }

            this.uri = uri;

            this.data = this.getProject();

        },
        computed: {
            mode() {
                if (this.related_with == "tester" && this.related_id == "") { return 'tester.match' }
                else if (this.related_with == "tester" && this.related_id != "") { return 'tester.project' }
                else if (this.related_with == "company" && this.related_id != "") { return 'company.project' }
                else if (this.related_with == "") { return 'project' }
            },
            projects() {
                return this.data;
            },
            base_path() {
                return $.param(this.filter);
            }
        },
        watch: {

            filter: {
                handler: function (modifiedProject) {
                    this.getProject();
                },
                deep: true
            },
            page() {

                this.getProject();

            }

        },
        methods: {

            getProject() {
                $.ajax({
                    url: this.uri,
                    method: "GET",
                    data: {
                        filter: this.filter,
                        page: this.page + 1,
                    }
                }).done((response) => {
                    this.data = response.data;

                    // _.each(response.data[5].attachments, function (a) {
                    //     console.log(a.type)
                    // })

                    if (this.maxCount !== undefined) {
                        this.data = this.data.slice(0, this.maxCount);
                    }

                    this.total = response.total;
                })
            },
            setListViewMode(mode) {
                this.list_view_mode = mode;
            },
            onClickedFilterSubmit() {
                this.getProject(this.uri);
            },
            onClickedProject (event, project) {
                console.log('event',event.type);
                console.log('event',event.type);
                if (event.target.nodeName === "BUTTON") return;
                this.selected_project = project.id;

                this.$emit('click_project', project.id);
            },
            onClickedResetFilter() {
                 _.each(this.filter, (value, key) => {
                     this.filter[key] = "";
                });
                 this.getProject();
            },
            statusToKor(status) {
                let text = "";

                if (this.is_admin == "true") {
                    switch (status) {
                        case "request": text = "프로젝트 신청"; break;
                        case "request_fail": text = "프로젝트 신청 거부"; break;
                        case "request_pass": text = "프로젝트 신청 승인"; break;
                        case "recruiting": text = "테스터 모집 중"; break;
                        case "recruiting_done": text = "테스터 모집 완료"; break;
                        case "testing": text = "테스트 진행"; break;
                        case "testing_done": text = "테스트 완료"; break;
                        case "appraisal": text = "평가 중"; break;
                        case "done": text = "완료"; break;
                    }
                } else {
                    switch (status) {
                        case "request":
                        case "request_fail":
                        case "request_pass": text = "대기중"; break;
                        case "recruiting": text = "모집중"; break;
                        case "recruiting_done": text = "모집완료"; break;
                        case "testing": text = "진행중"; break;
                        case "testing_done":
                        case "appraisal":
                        case "done": text = "완료"; break;
                    }
                }

                return text;
            },
            attachmentsOf(project, type) {
                return _.filter(project.attachments, (attachment) => {
                    return attachment.type == type;
                })
            },
            thumbnail(project) {

                let screenshot = this.attachmentsOf(project, 'screenshot');

                if ( screenshot.length == 0) {
                    screenshot = [
                        {
                            file_name: "card-top.jpg"
                        }
                    ]

                    return screenshot[0]
                }

                screenshot = _.sortBy(screenshot, [function(sc) { return sc.created_at; }]);

                return screenshot[0];
            }

        },
        filters: {
            applicationStatusToText(value,projectStatus) {


                let testProjectStatus = ['testing','testing_done','appraisal','done'];


                let map = {
                    'pending': '심사중',
                    'fail': '탈락',
                    'pass': '참여 승인',
                    'cancel': '취소',
                }

                if(value === 'pending' && testProjectStatus.indexOf(projectStatus) > -1){
                    return '불합격';
                }

                return map[value];
            },
            n2br(text) {
                if (text === null || text == "") {
                    return "보상 정보가 없습니다.";
                }

                return text.replace(/\n/g, '<br/>');
            }
        }

    }
</script>

<style lang="scss" scoped>

    #project-list {
        .project-list-header {
            margin-bottom: 1em;
        }
        .table {
            margin-bottom: 0;
        }
        .input-group {
            margin-right: 1em;

            .input-group-addon {
                background-color: #fff;
            }
        }
        .project-card {
            margin-bottom: 30px;
            background-color: #fff;

            .project-card-header {
                .project-card-header__status {
                    position: absolute;
                    line-height: 2rem;
                    padding: 0 1em;

                    &.project-card-header__status--recruiting {
                        background-color: #ed1c22;
                    }
                    &.project-card-header__status--request, &.project-card-header__status--request_pass {
                        background-color: #959595;
                    }
                    &.project-card-header__status--testing {
                        background-color: #8fc41e;
                    }
                    &.project-card-header__status--done, &.project-card-header__status--testing_done, &.project-card-header__status--appraisal {
                        background-color: #855fa8;
                    }
                }
            }

            .project-card-info {
                dt {
                    &:first-child {
                        margin-top: 0;
                    }
                    margin-top: 1.2em;
                    margin-bottom: 0.6em;
                }
                dd {
                    font-size: 14px;
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/ProjectList.vue